export default "__VITE_ASSET__DKQttTg9__"